import cn from "classnames";
import Image from "next/image";
import { useState } from "react";
import * as uuid from "uuid";

import eyeSlashSvg from "@images/svg/eye-slash.svg";
import Tooltip from "@ui-kit/Tooltip/Tooltip";

import s from "./HiddenInput.module.scss";

const HiddenInput = ({
  tooltipText = "",
  required = false,
  isError,
  errors,
  label,
  className,
  withoutMessage = false,
  errorWithoutMessage = false,
  ...props
}) => {
  const id = uuid.v4();
  const [type, setType] = useState("password");

  const toggleCode = () => {
    setType(type === "text" ? "password" : "text");
  };

  const classes = cn(
    s.hiddenInput,
    type === "text" && s.visible,
    (errors || errorWithoutMessage) && s.error,
    withoutMessage && s.withoutMessage,
    props.readOnly && s.readOnly,
    props.disabled && s.disabled,
    className,
  );

  return (
    <div className={classes}>
      {label && (
        <label htmlFor={id}>
          {`${label}${required ? " *" : ""}`}
          {tooltipText && (
            <Tooltip centred={false} className={s.tooltip}>
              {tooltipText}
            </Tooltip>
          )}
        </label>
      )}
      <div className={s.input}>
        <input id={id} type={type} {...props} />
        {!props.readOnly && !props.disabled && (
          <div className={s.eye} onClick={toggleCode}>
            <Image width={16} height={13} src={eyeSlashSvg} alt="" />
          </div>
        )}
      </div>
      {errors && <div className={s.message}>{errors}</div>}
    </div>
  );
};

export default HiddenInput;
